import View from '@/components/atomic/atoms/layout/view/styled';
import type { HamburgerButtonProps } from '@/components/atomic/atoms/navigation/hamburger-wrapper/typings';
import MenuItemText from '@/components/atomic/atoms/navigation/menu/text';
import { BasicComponentProps } from '@/typings/generic';
import styled, { CSSObject } from '@emotion/styled';

const HamburgerWrapper = styled(View)<
	HamburgerButtonProps & BasicComponentProps
>(({ theme, $open }) => {
	const style: CSSObject = {
		height: $open ? 2 : 12,
		width: 14,
		position: 'relative',
		transition: 'height 0.3s ease',
		transitionDelay: !$open ? '0.3s' : '0s',
		[theme.media.desktop.sm]: {
			height: $open ? 3.43 : 20,
			width: 24,
		},
		[`& + ${MenuItemText}`]: {
			fontFamily: theme.font.families.secondary.demiBold,
			fontSize: 8,
			fontWeight: 600,
			letterSpacing: '1.6px',
			lineHeight: '15.04px',
			[theme.media.desktop.laptop]: {
				fontSize: 11,
				lineHeight: '14.96px',
			},
		},
	};

	return style;
});

export default HamburgerWrapper;
